
import React, { Component, PropTypes } from 'react';
import classnames from 'classnames';


import './style.scss';
import Link from 'components/Link';

class AccordionItem  extends Component {

  constructor() {
    super();

    this.handleLinkClick = this.handleLinkClick.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (this.props.onItemOpen && this.props.isExpanded && !prevProps.isExpanded) {
      this.props.onItemOpen(this.refs.accordionItem.offsetTop);
    }
  }

  handleLinkClick(event) {
    if(this.props.url) {
      return;
    }

    event.preventDefault();

    if(this.props.onClick) {
      this.props.onClick();
    }
  }


  render() {
    const className = classnames('AccordionItem', {
      'is-group': this.props.isGroup,
      'is-expanded': this.props.isExpanded,
      'is-empty': this.props.isEmpty,
      'is-for-forum': this.props.isForForum,
      'is-for-magazine': this.props.isForMagazine
    });

    const { url = '_' } = this.props;

    return (
      <div className={className} ref="accordionItem">
        <div className="inner">
          <h4>{this.props.title}</h4>
          <span className="article-count">{this.props.countInfo}</span>
          <div className="icon"><img src={this.props.imageUrl} /></div>
          <span className="arrow"></span>

          <Link to={url} onClick={this.handleLinkClick}>&nbsp;</Link>
        </div>

        {(() => {
          if(React.Children.count(this.props.children) > 0) {
            return (
              <div className="topics-list">
                {this.props.children}
              </div>
            );
          }
        })()}
      </div>
    );
  }
}

AccordionItem.propTypes = {
  title: PropTypes.string,
  countInfo: PropTypes.string,
  url: PropTypes.string,
  imageUrl: PropTypes.string,
  children: PropTypes.arrayOf(PropTypes.element),
  isGroup: PropTypes.bool,
  isExpanded: PropTypes.bool,
  isEmpty: PropTypes.bool,
  isForForum: PropTypes.bool,
  isForMagazine: PropTypes.bool,
  onItemOpen: PropTypes.func,
  onClick: PropTypes.func
};

export default AccordionItem;



/** WEBPACK FOOTER **
 ** ./src/members/Main/__shared__/components/Accordion/AccordionItem/index.js
 **/